<div class="filter-multi-select">
	<div class="label-default">{{ labelKey | translate }}</div>

	<!-- AUTOCOMPLETE MODE -->
	<ng-container *ngIf="showSearchInput">
		<mat-form-field [appearance]="appearance" class="filter-multi-select__field mat-input-helper">
			<mat-label>{{ placeholderKey | translate }}</mat-label>
			<input matInput [formControl]="autocompleteControl" [matAutocomplete]="auto" [disabled]="isSelectDisabled" />
			<mat-autocomplete #auto="matAutocomplete">
				<mat-option
					*ngFor="let option of filteredOptions$ | async; trackBy: trackByValue"
					[value]="option"
					(onSelectionChange)="onAutocompleteOptionSelected(option)"
				>
					{{ optionLabels ? getOptionLabel(option) : (getOptionLabel(option) | translate) }}
				</mat-option>
			</mat-autocomplete>
		</mat-form-field>
	</ng-container>

	<!-- SELECT MODE -->
	<ng-container *ngIf="!showSearchInput">
		<mat-form-field [appearance]="appearance" class="filter-multi-select__field mat-select-helper">
			<mat-select
				[value]="value"
				[multiple]="true"
				[disabled]="isSelectDisabled"
				[disableOptionCentering]="true"
				[placeholder]="placeholderKey | translate"
				(selectionChange)="onSelectionChange($event.value)"
			>
				<mat-select-trigger>
					<ng-container *ngIf="value.length; else placeholderTpl">
						{{ selectedCountKey | translate : { count: value.length } }}
					</ng-container>
					<ng-template #placeholderTpl>
						{{ placeholderKey | translate }}
					</ng-template>
				</mat-select-trigger>

				<mat-option *ngFor="let option of options; trackBy: trackByValue" [value]="option">
					{{ optionLabels ? getOptionLabel(option) : (getOptionLabel(option) | translate) }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>

	<div
		*ngIf="value.length && !isSelectDisabled"
		class="filter-multi-select__chips"
		[attr.aria-label]="selectedListAriaLabelKey | translate"
	>
		<app-filter-chip
			*ngFor="let option of value; trackBy: trackByValue"
			class="filter-multi-select__chips__item"
			[label]="optionLabels ? getOptionLabel(option) : (getOptionLabel(option) | translate)"
			[removeAriaLabel]="removeSelectionAriaLabelKey | translate"
			(remove)="removeOption(option)"
		></app-filter-chip>
	</div>
</div>
